import React, { createContext, useState } from "react";

export interface looseObject {
  [key: string]: any;
}
export type ControlBarContextType = {
  selection: {};
  setSelection: (value: looseObject) => void;
};

export const ControlBarContext = createContext<ControlBarContextType>({
  selection: {},
  setSelection: () => {},
});

export const ControlBarProvider = ({ children }: any) => {
  const [selection, setSelection] = useState({});

  return (
    <ControlBarContext.Provider
      value={{
        selection,
        setSelection,
      }}
    >
      {children}
    </ControlBarContext.Provider>
  );
};
